import React from 'react'
import { IStepHelpSteps } from 'app_types/components/helpSteps/helpStepsTypes';
import { I18nUtil } from 'app_utils/i18n';

const i18nUtil = new I18nUtil()

const chatbotImage = require('app_assets/images/resources/chatbot.jpg')

const steps: IStepHelpSteps[] = [
  {
    target: '#go_to_moodle',
    title: 'Ingreso a cursos',
    content: (
      <div>
        <div className="content">
          {i18nUtil.getTranslate('components.help_module.student_dashboard.header_go_to_moodle')}
        </div>
      </div>
    ),
  },
  {
    target: '#go_to_campus',
    title: 'Campus',
    content: (
      <div>
        <div className="content">
          {i18nUtil.getTranslate('components.help_module.student_dashboard.header_go_to_campus')}
        </div>
      </div>
    ),
  },
  {
    target: '#student_user_info',
    title: 'Perfil',
    content: (
      <div>
        <div className="content">
          {i18nUtil.getTranslate('components.help_module.student_dashboard.student_dashboard_profile')}
        </div>
      </div>
    ),
    placement: 'right-start'
  },
  {
    target: '#student_my_courses',
    title: 'Información de programas de formación',
    content: (
      <div>
        <div className="content">
          {i18nUtil.getTranslate('components.help_module.student_dashboard.student_dashboard_courses')}
        </div>
      </div>
    ),
    placement: 'right-start'
  },
  {
    target: '#learning_way',
    title: 'Ruta de aprendizaje',
    content: (
      <div>
        <div className="content">
          {i18nUtil.getTranslate('components.help_module.student_dashboard.student_dashboard_learning_way')}
        </div>
      </div>
    ),
    placement: 'top'
  },
  {
    target: '#student_dashboard_activity',
    title: 'Estadísticas',
    content: (
      <div>
        <div className="content">
          {i18nUtil.getTranslate('components.help_module.student_dashboard.student_dashboard_activity')}
        </div>
      </div>
    ),
    placement: 'top'
  },
  {
    target: '#student_dashboard_details',
    title: 'Actividades del curso',
    content: (
      <div>
        <div className="content">
          {i18nUtil.getTranslate('components.help_module.student_dashboard.student_dashboard_details')}
        </div>
      </div>
    ),
    placement: 'top'
  },
  {
    target: '#news_campus',
    title: 'Mantengámonos al día',
    content: (
      <div>
        <div className="content">
          {i18nUtil.getTranslate('components.help_module.student_dashboard.student_dashboard_section_news')}
        </div>
      </div>
    ),
  },
  {
    target: '#menu',
    title: 'Menú lateral',
    content: (
      <div>
        <div className="content">
          {i18nUtil.getTranslate('components.help_module.student_dashboard.student_dashboard_menu')}
        </div>
      </div>
    ),
    placement: 'right-start'
  },
  {
    target: '#student_dashboard_related_courses',
    title: 'Cursos relacionados',
    content: (
      <div>
        <div className="content">
          {i18nUtil.getTranslate('components.help_module.student_dashboard.student_dashboard_related_courses')}
        </div>
      </div>
    ),
    placement: 'right-start'
  },
  {
    target: 'body',
    placement: 'center',
    title: 'Asistente virtual Daniela',
    content: (
      <div>
        <div className="content" style={{flexDirection: 'column'}}>
          <div>
            Con el asistente virtual <b>Daniela</b> puede acceder al <b>soporte estudiantil</b>, en la opción 2
          </div>
          <img src={chatbotImage} alt="Chatbot" style={{width: '200px', margin: '0 auto'}}/>
        </div>
      </div>
    ),
  },
]

export default steps;
